import { c as _c } from "react/compiler-runtime";
import type { CartOutputDto } from "@sticker-giant/sg-frontend-common";
import { CouponStatus, CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import { IconTag } from "@tabler/icons-react";
import { Skeleton } from "@/components/ui/skeleton";
import { useIsCartMutating } from "@/queries/useIsCartMutating";
interface Props {
  cart: CartOutputDto;
}
export function OrderSummaryCoupon(t0) {
  const $ = _c(14);
  const {
    cart
  } = t0;
  const isMutating = useIsCartMutating();
  if (cart.couponStatus !== CouponStatus.APPLIED || !cart.couponCode) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconTag size={16} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== cart.couponCode) {
    t2 = <div className="mb-0.5 flex items-center gap-2">{t1}<span className="font-medium uppercase">{cart.couponCode}</span></div>;
    $[1] = cart.couponCode;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cart.couponDiscountDescription) {
    t3 = cart.couponDiscountDescription && <span className="text-neutral-500">{cart.couponDiscountDescription}</span>;
    $[3] = cart.couponDiscountDescription;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex flex-col text-sm">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== cart.pricing || $[9] !== isMutating) {
    t5 = isMutating ? <Skeleton className="h-4 w-16 bg-neutral-200" /> : <span className="font-medium text-green-600">{`-${CurrencyFormatter.formatUSD(cart.pricing.couponDiscountTotal)}`}</span>;
    $[8] = cart.pricing;
    $[9] = isMutating;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex justify-between">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}